import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import {
  LIFE_MARKET_SCAN_WAITING_TIME,
  MBI_MARKET_SCAN_WAITING_TIME,
} from 'constants/marketScan';
import { TASK_TYPES } from 'constants/notification';
import {
  MARKET_SCAN_PURCHASE_ROUTE,
  MARKET_SCAN_RESULTS_ROUTE,
  MARKET_SCAN_STATUS_ROUTE,
} from 'constants/routes';
import moment from 'moment';
import { INotification } from 'types';
import {
  getMarketScanEndScreenRoute,
  getMarketScanLifeResultsRoute,
  getMarketScanResultsRoute,
} from './route';
import history from 'helpers/history';

export const showNotificationByRoute = () => {
  const currentPath = window.location.pathname;

  const routesToCheck = [
    MARKET_SCAN_PURCHASE_ROUTE,
    MARKET_SCAN_RESULTS_ROUTE,
    MARKET_SCAN_STATUS_ROUTE,
  ];

  return !routesToCheck.some((route) => currentPath.includes(route));
};

// Life and MBI quote synchronously — flip their PENDING ("Scanning")
// notification to READY locally once the user has seen it.
const SYNC_QUOTE_POLICY_TYPES: string[] = [
  INSURANCE_TYPES_NAMES.LIFE,
  INSURANCE_TYPES_NAMES.MBI,
];

export const updatePendingLifePolicyScanToReady = (notification: INotification) => {
  if (SYNC_QUOTE_POLICY_TYPES.includes(notification.policyType) && notification.notificationType === TASK_TYPES.POLICY_SCAN_PENDING) {
    notification.notificationType = TASK_TYPES.POLICY_SCAN_READY
  }
  return notification
}

export const getSyncQuoteWaitingTime = (policyType?: string) => {
  switch (policyType) {
    case INSURANCE_TYPES_NAMES.LIFE:
      return LIFE_MARKET_SCAN_WAITING_TIME;
    case INSURANCE_TYPES_NAMES.MBI:
      return MBI_MARKET_SCAN_WAITING_TIME;
    default:
      return 0;
  }
};

export const isSyncQuoteScanWaiting = (
  policyType?: string,
  createdAt?: string,
) => {
  const waitingTime = getSyncQuoteWaitingTime(policyType);
  if (!waitingTime || !createdAt) return false;
  return moment().diff(moment(createdAt), 'milliseconds') < waitingTime;
};

// Mirror of redirectToLifeMarketScanResults for MBI: within the waiting
// window, send the user to the waiting screen; after that, straight to
// results.
export const redirectToMbiMarketScanResults = (item: { id: string, sk: string, createdAt: string }) => {
  if (isSyncQuoteScanWaiting(INSURANCE_TYPES_NAMES.MBI, item.createdAt)) {
    history.push(getMarketScanEndScreenRoute(item.id));
  } else {
    history.push(getMarketScanResultsRoute(item.id, item.sk));
  }
}

export const redirectToLifeMarketScanResults = (item: { id: string, sk: string, createdAt: string }) => {
  const diff = moment().diff(moment(item.createdAt), "milliseconds")
  if (diff < LIFE_MARKET_SCAN_WAITING_TIME) {
    const waitingTime = (LIFE_MARKET_SCAN_WAITING_TIME - diff)
    history.push(
      getMarketScanLifeResultsRoute(
        item.id,
        item.sk,
        waitingTime
      ),
    );
  } else {
    history.push(
      getMarketScanLifeResultsRoute(
        item.id,
        item.sk
      ),
    );
  }
}